export function isHttpError(error) {
    if (!(error instanceof Error)) {
        return false;
    }
    return error.isWixHttpError === true;
}
export function extractHttpErrorDetails(error) {
    return {
        requestId: error.requestId,
        config: extractHttpErrorConfig(error),
        response: extractHttpErrorResponse(error)
    };
}
function extractHttpErrorConfig(error) {
    const { url, method, params, data } = error.config ?? {};
    return {
        url,
        method,
        ...params && {
            params: tryParseJSON(params)
        },
        ...data && {
            data: tryParseJSON(data)
        }
    };
}
function extractHttpErrorResponse(error) {
    const { status, statusText, data } = error.response ?? {};
    return {
        status,
        statusText,
        ...data && {
            data: tryParseJSON(data)
        }
    };
}
export function getSerializableHttpError(error) {
    const { status, statusText, data } = error.response ?? {};
    const { url, method, params, data: configData } = error.config ?? {};
    return {
        code: error.code,
        config: {
            url,
            method,
            params: tryParseJSON(params),
            data: tryParseJSON(configData)
        },
        response: {
            status,
            statusText,
            data: tryParseJSON(data)
        },
        isWixHttpError: error.isWixHttpError,
        requestId: error.requestId
    };
}
function tryParseJSON(value) {
    if (typeof value === 'string') {
        try {
            return JSON.parse(value);
        } catch  {
            return value;
        }
    }
    return value;
}

//# sourceMappingURL=http-error.js.map